module.exports = __webpack_public_path__ + "static/media/marriott-hotels.marriott.com_marriott-hotels-ted.6e62bef8.jpg";